/* Botones de la tarjeta de producto: "Añadir al carrito" y "Comprar ahora".
 * Productos de una sola variante: se agregan por /cart/add.js y usan el mini-carrito del tema.
 * Con varias variantes los botones son enlaces a la ficha (sin JS). */
(function () {
  if (window.__lamiCardActions) return;
  window.__lamiCardActions = true;

  function say(btn, text) {
    var msg = btn.closest(".lami-card-actions") && btn.closest(".lami-card-actions").querySelector(".lami-card-actions__msg");
    if (msg) msg.textContent = text || "";
  }

  function track(btn) {
    try {
      if (typeof window.gtag !== "function") return;
      var price = Number(btn.dataset.price) / 100;
      window.gtag("event", "add_to_cart", {
        currency: btn.dataset.currency || "COP",
        value: price,
        items: [{ item_id: btn.dataset.sku || String(btn.dataset.variantId), item_name: btn.dataset.name, price: price, quantity: 1 }],
      });
    } catch (e) { console.error(e); }
  }

  async function add(btn, buyNow) {
    if (btn.classList.contains("is-loading")) return;
    var row = btn.closest(".lami-card-actions__row");
    var buttons = row ? Array.prototype.slice.call(row.querySelectorAll(".lami-btn")) : [btn];
    buttons.forEach(function (b) { b.classList.add("is-loading"); b.setAttribute("aria-busy", "true"); });
    say(btn, "");
    var cartEl = document.querySelector("cart-drawer");
    try {
      var body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
      var useDrawer = !buyNow && cartEl && typeof cartEl.getSectionsToRender === "function" && typeof cartEl.renderContents === "function";
      if (useDrawer) {
        body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(",");
        body.sections_url = window.location.pathname;
        if (typeof cartEl.setActiveElement === "function") cartEl.setActiveElement(document.activeElement);
      }
      var routes = (window.routes && window.routes.cart_add_url) || "/cart/add";
      var res = await fetch(routes + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify(body),
      });
      var data = await res.json();
      if (!res.ok || data.status) {
        say(btn, data.description || data.message || "No pudimos agregar el producto al carrito.");
        return;
      }
      track(btn);
      if (buyNow) {
        window.location = "/checkout";
        return;
      }
      if (useDrawer && data.sections) {
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "lami-card", productVariantId: Number(btn.dataset.variantId), cartData: data });
        }
        cartEl.renderContents(data, !document.body.classList.contains("page-overlay-cart-on"));
      } else {
        window.location = (window.routes && window.routes.cart_url) || "/cart";
      }
    } catch (err) {
      console.error(err);
      say(btn, "Ocurrió un error de conexión. Intenta de nuevo.");
    } finally {
      buttons.forEach(function (b) { b.classList.remove("is-loading"); b.removeAttribute("aria-busy"); });
    }
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-card-add], [data-card-buy]");
    if (!btn) return;
    e.preventDefault();
    add(btn, btn.hasAttribute("data-card-buy"));
  });
})();
